var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnBulletSmall12 = function SvgLightIcnBulletSmall12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "light_icn_bullet_small_12_svg__a",
    width: 12,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 12h12V0H0z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#light_icn_bullet_small_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.125 7.5A1.377 1.377 0 0 1 4.75 6.125c0-.758.617-1.375 1.375-1.375S7.5 5.367 7.5 6.125 6.883 7.5 6.125 7.5",
    clipRule: "evenodd"
  }))));
};
export default SvgLightIcnBulletSmall12;